import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import { Home } from "./screens/Home";
import { ContactUs } from "./screens/ContactUs";
import { AboutUs } from "./screens/AboutUs";
import { Header } from "@components/Header";
import { Footer } from "@components/Footer";
import { ChurchEvent, getChurchEvents, getNextNEvents } from "./sheets/utils";
import { LogIn } from "./screens/LogIn";
import { Bibliothek } from "./screens/Bibliothek";
import { AuthProvider } from "@components/AuthContext";
import { ProtectedRoute } from "@components/ProtectedComponent/ProtectedComponent";
import { Calendar } from "./screens/Calendar";
import { Services } from "./screens/Services/Services";
import { Impressum } from "./screens/Impressum";
require('dotenv').config()


export const App = () => {
    const [events, setEvents] = useState<ChurchEvent[]>([]);

    useEffect(() => {
        (async () => {
            const events = await getChurchEvents();
            setEvents(events);
        })()

    }, [])

    return (
        <Router>
            <div className="mx-auto w-[95%] lg:w-[75%] flex flex-col min-h-screen justify-between">
                <AuthProvider>

                    <Header />
                    <Routes>
                        <Route path="/" element={<Home nextThreeEvents={getNextNEvents([...events], 3)} />} />
                        <Route path="/contact-us" element={<ContactUs />} />
                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/log-in" element={<LogIn />} />
                        <Route path="/bibliothek" element={<ProtectedRoute component={<Bibliothek/>} />} />
                        <Route path="/calendar" element={<Calendar events={events} />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/impressum" element={<Impressum />} />
                    </Routes>

                    {/* Empty Space */}
                    <div className="pt-20"></div>
                    <Footer />
                </AuthProvider>
            </div>
        </Router>
    )
}